import React from 'react';
import { Modal, OverlayTrigger, Button } from 'react-bootstrap';

export default class FAQ extends React.Component {
  render() {
    return <Modal show={this.props.show} onHide={this.props.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>FAQ</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <ul>
             <li>Why Bengaluru?<br /><br />We are based out of Bengaluru, and this is our contribution to this city. Solve Ninjas are pan-India, so we are looking forward to them adding information here about their neighbourhood.</li>
          </ul>
          <ul>
             <li>Where are you getting addresses and numbers from?<br /><br />We have gone to the official websites and gotten numbers. If there are errors in the numbers/addresses/names, please let us know!</li>
          </ul>
          <ul>
             <li>Where is Air Quality Data from?<br /><br />We are currently pulling it off the Govt of India (open data) website, as it is put up. We don&rsquo;t have any control over the information shared. We are adding data from affordable air quality monitors developed by our Solve Ninjas in the next release.</li>
          </ul>
          <ul>
             <li>What is the blue box on the map?<br /><br />It is your ward boundary. We are using wards as our basic unit of categorizing information.</li>
          </ul>
          <ul>
             <li>How do I use this site?<br /><br />As it loads, give access to your location. The map will load. Zoom out till you see the ward boundary. There is an invisible marker in the centre of the screen. Based on this, information is displayed in the tabs on the side.&nbsp; Move the map by left click+drag to change your location and see the relevant information</li>
          </ul>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.props.handleClose}>Close</Button>
          </Modal.Footer>
        </Modal>;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/FAQ.js